<template>
  <div>
    <div class="footers text-center">
      <img src="@/assets/img/vector/png.png" width="100px" />
      <ul class="list-unstyled list-inline">
        <li class="list-inline-item"><a href="/"> Home</a></li>
        <li class="list-inline-item"><a href="/Books">Books</a></li>
        <li class="list-inline-item"><a href="/music">music</a></li>
        <li class="list-inline-item"><a href="/films">films</a></li>
        <li class="list-inline-item"><a href="/history">history</a></li>
        <li class="list-inline-item"><a href="/geography">geography</a></li>
        <li class="list-inline-item"><a href="/art">art</a></li>
        <li class="list-inline-item"><a href="/politics">politics</a></li>
        <li class="list-inline-item"><a href="/cartoon">cartoon</a></li>
        <li class="list-inline-item"><a href="/vehiles">vehiles</a></li>
      </ul>

      <div class="svg-group">
        <ul class="list-inline list-unstyled">
          <li class="list-inline-item">
            <i class="fab fa-facebook-f"></i>
          </li>
          <li class="list-inline-item">
            <i class="fab fa-twitter"></i>
          </li>
          <li class="list-inline-item">
            <i class="fab fa-google-plus-g"></i>
          </li>
          <li class="list-inline-item">
            <i class="fab fa-instagram"></i>
          </li>
          <li class="list-inline-item">
            <i class="fab fa-youtube-square"></i>
          </li>
        </ul>
      </div>

      <div class="copyright">
        &copy; Copyright 2016 Start. Designed by
        <span>malak khaled</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footers'
}
</script>
